import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.BusinessBankStatements.title',
        defaultMessage:
            'Business bank statements for the last {quantifier} months (from today)'
    },
    title1Month: {
        id: '_.BusinessBankStatements.title1Month',
        defaultMessage:
            'Business bank statements for the last 1 month (from today)'
    },
    linkBankAccount: {
        id: '_.BusinessBankStatements.link_my_account',
        defaultMessage: 'Link my bank account'
    },
    linkedBankAccountStatus: {
        id: '_.BusinessBankStatements.linkedBankAccountStatus',
        defaultMessage: 'Your {bankName} account is now linked.'
    },
    uploadPDF: {
        id: '_.BusinessBankStatements.upload_pdf',
        defaultMessage: 'Upload statements manually'
    },
    howToShare: {
        id: '_.BusinessBankStatements.how_to_share',
        defaultMessage: 'How would you like to share these?'
    },
    cannotLinkAccount: {
        id: '_.BusinessBankStatements.cannot_link_account',
        defaultMessage: 'My bank is not available to link'
    }
});
